import React from "react";
import s from "./style.module.css";
import cn from "classnames";

const ToggleButtons = ({ options = [], onChange, selected, large }) => {
  const handleChange = (e) => onChange(e.target.value);

  return (
    <div className={cn(s.wrap, { [s.large]: large })}>
      {options.map((d, i) => {
        return (
          <>
            <input
              className={s.radio}
              value={d.value}
              onChange={handleChange}
              type="radio"
              checked={d.value === selected}
              id={d.value}
            />
            <label
              key={`label-${d.keyword}`}
              htmlFor={d.value}
              className={s.label}
            >
              {d.label}
            </label>
          </>
        );
      })}
    </div>
  );
};

export default ToggleButtons;
